"use strict";

jQuery(document).ready(function ($) {
  //If there are two team blocks in a row on the front end, put them in the same container
  if ($('#main').length) {
    $('.team-block').each(function (i) {
      if (i == 0) {//Do nothing
      } else {
        //Get all interior elements and add them to previous team block. Remove container.
        if ($(this).prev().hasClass('team-block')) {
          var guts = $(this).html();
          $(this).prev().append(guts);
          $(this).remove();
        }
      }
    });

    if ($(window).width() < 768) {
      $('.team-block__team img').on('click', function () {
        if ($(this).parents('.team-block__team').hasClass('open')) {
          $(this).parents('.team-block__team').removeClass('open');
        } else {
          $('.team-block__team').removeClass('open');
          $(this).parents('.team-block__team').toggleClass('open');
        }
      });
      $('.team-block__team .close').on('click', function () {
        $(this).parents('.team-block__team').removeClass('open');
      });
    }
  }
});
//# sourceMappingURL=script.js.map
